// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-info-box__add-list-edit-name input[data-v-0ef39822]{width:120px;height:40px;padding:0 10px}.product-info-box__add-list-edit-name .product-info-box__add-list-btn[data-v-0ef39822]{height:40px}", ""]);
// Exports
module.exports = exports;
